import * as React from "react";
import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";
import { getPrimaryColor } from "../../../src/utils/ColorsFunctions";
import { useAppSelector } from "../../../src/hooks/reduxHooks";

const CloseIcon = (props: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  width?: string;
  height?: string;
}) => {
  const width = props.width ?? "16";
  const height = props.height ?? "16";
	const user = useAppSelector((s) => s.auth.subUser!);

  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 16 16`}
      fill={props.fill ?? getPrimaryColor(user)}
      style={props.style}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.852053 0.852053C1.98812 -0.284018 3.83006 -0.284018 4.96613 0.852053L8 3.88592L11.0339 0.852053C12.1699 -0.284018 14.0119 -0.284018 15.1479 0.852053C16.284 1.98812 16.284 3.83006 15.1479 4.96613L12.1141 8L15.1479 11.0339C16.284 12.1699 16.284 14.0119 15.1479 15.1479C14.0119 16.284 12.1699 16.284 11.0339 15.1479L8 12.1141L4.96613 15.1479C3.83006 16.284 1.98812 16.284 0.852053 15.1479C-0.284018 14.0119 -0.284018 12.1699 0.852053 11.0339L3.88592 8L0.852053 4.96613C-0.284018 3.83006 -0.284018 1.98812 0.852053 0.852053Z"
      />
    </Svg>
  );
};
export default CloseIcon;
